/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/deleteUser.config.json";
import notification from "../config/notifications.config.json";
import axios from "axios";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { DELETE_USER } from "../graphql";
import { VApplication } from "../../../application";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface deleteUserProps {
  email: string;
}

export interface IDeleteUserMethods extends IPluginMethodMap {
  getDeleteUser(args: deleteUserProps): Promise<any>;
}

export class DeleteUserService implements IAgentPlugin {
  readonly methods: IDeleteUserMethods;

  constructor() {
    this.methods = {
      getDeleteUser: this.getDeleteUser.bind(this),
    };
  }

  async getDeleteUser(args: deleteUserProps) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      // if (client) {
      //   const res = await client.mutate({
      //     mutation: DELETE_USER,
      //     variables: {
      //       email: args,
      //     },
      //     fetchPolicy: "no-cache",
      //   });
      //   if (res?.data) {
      //     return {
      //       ...res?.data?.removeUser,
      //       notification: notification?.deleteUserSuccess,
      //     };
      //   }
      // }
    } catch (err: any) {
      throw err;
    }
  }
}
